function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditRoundBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 22121",
    transform: "translate(-487.15 -177.15)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 625",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(487.15 177.15)",
    style: {
      fill: "#1b74e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16314",
    d: "M2.964 12.086a.783.783 0 0 0-.22.439l-.737 5.136a.779.779 0 0 0 .886.886l5.136-.737a.784.784 0 0 0 .439-.22l6.054-6.046L9.01 6.04z",
    transform: "translate(494.784 183.959)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16315",
    d: "m13.27 3.131-.91.91 5.5 5.5.917-.91c3.633-3.652-1.877-9.141-5.513-5.5z",
    transform: "translate(492.548 184.845)",
    style: {
      fill: "#f4f4f4"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRoundBlue);
export default __webpack_public_path__ + "static/media/edit-round-blue.f22df32509e3739d0eb183e78cb6b58c.svg";
export { ForwardRef as ReactComponent };